import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { BridgeService, SessionState, SessionStateModel, GetKeyMapAWS, SetLinkAccountFromApp, SetMsisdn, SetMsisdnFromApp, compareVersion, WindowService } from '@myvf/core';
import { Store } from '@ngxs/store';
import { map, take } from 'rxjs/operators';
import CryptoAES from 'crypto-js/aes';
import CryptoENC from 'crypto-js/enc-utf8';
import { environment } from 'src/environments/environment';
import { isInEditor } from '@myvf/aem';
import { AnchorService } from './anchor';

export * from './anchor';
export * from './loader';
export * from './myvf-shared.module';
export { NATIVE_ANCHOR } from './native-anchor';
export * from './notification';
export * from './sticky';
export * from './tagging';

@Injectable()
export class CurrentMsisdnResolver  {
  constructor(public store: Store) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    const {
      queryParams: {msisdn, linkAccountId, cliNumber},
    } = route;

    // TODO verificare
    // const decMsisdn = msisdn ? CryptoAES.decrypt(msisdn.toString(), 'sdaavadvxzxzcwwddadadasdad').toString(CryptoENC) : null;

    // return msisdn ? this.store.dispatch(new SetMsisdnFromApp({msisdn})).pipe(map(() => msisdn)) : '';

    if(!!msisdn) {
      this.store.dispatch(new SetMsisdnFromApp({msisdn})).pipe(map(() => msisdn));
    }
    if(!!linkAccountId || !!cliNumber) {
      this.store.dispatch(new SetLinkAccountFromApp({ fixedLineInfo: { linkAccountId, cliNumber } })).pipe(map(() => ({linkAccountId, cliNumber})));
    }
    return;
  }
}

@Injectable()
export class CheckMsisdnResolver  {
  constructor(public store: Store, public bridge: BridgeService, public router: Router, public activateRoute: ActivatedRoute, public anchorService: AnchorService, private win: WindowService) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    const {currentItem: {msisdn, fixedLineInfo}, isOverlay}: SessionStateModel = this.store.selectSnapshot(SessionState);

    if (!msisdn) {
      // this.bridge.openSimSelector(null, isOverlay);
      const pageUrl = window.location.origin + '/content/myvf-business/webviews/change/sim-change.html';
      const anchorUrl = this.anchorService.makeAnchor(pageUrl, true);

      this.bridge.showOverlay({
        url: anchorUrl,
        type: 'hybrid',
        overlayType: 'forced',
        forceFull: false
      });

      this.bridge
        .events
        .pipe(take(1))
        .subscribe((event) => {
          if (event instanceof SetMsisdn) {
            const {params} = event;
            this.store.dispatch(new SetMsisdnFromApp({msisdn: params})).subscribe(async (state) => {
              this.router.routeReuseStrategy.shouldReuseRoute = function () {
                return false;
              };
              await this.router.navigate([], {queryParams: this.activateRoute.snapshot.queryParams});
            });
          }
        });
    }
  }
}

@Injectable()
export class AwsAppConfigResolver  {
  constructor(public store: Store) {}

  resolve(route: ActivatedRouteSnapshot) {
    const {device: {appVersion}}: SessionStateModel = this.store.selectSnapshot(SessionState);

    if (!isInEditor() && (appVersion==='local' || compareVersion(appVersion, '6.14.0') >= 0)) {
      return this.store.dispatch(new GetKeyMapAWS()).pipe(map(() => true));
    }
  }
}
